import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  title: {
    fontWeight: 'bold'
  }
}))

export default function CustomDialog(props) {
  const classes = useStyles()
  const { handleClose, ...remainingProps } = props
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...remainingProps}
    >
      <DialogTitle id="alert-dialog-title" className={classes.title}>{props.title}</DialogTitle>
      {props.handleClose && (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={props.handleClose}
        >
          <CloseIcon />
        </IconButton>
      )}
      <DialogContent>
        <DialogContentText id="alert-dialog-description" children={props.content} />
      </DialogContent>
      <DialogActions>
      </DialogActions>
    </Dialog>
  )
}
